<template>
<div>
  <v-dialog
       v-model="selectDialog"
       width="500"
       scrollable
       persistent
    >
      <v-card>
        <v-card-title class="headline font-weight-regular">
                Subcondominios
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" @click="selectDialog = false">
                            <v-icon>fa-times</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-card-title>
        <v-card-text>
          <v-list>
                <template v-for="(subcondominio, i) in subcondominios">
                    <v-list-tile :key="`item-${i}`" :value="subcondominio" >
                        <v-list-tile-action>
                              <v-checkbox @input="temp_check = subcondominio.id"
                                          v-model="checked[subcondominio.id]" />
                          </v-list-tile-action>
                          <v-list-tile-content>
                              <span class="black--text">{{ subcondominio.nombre }}</span>
                          </v-list-tile-content>
                    </v-list-tile>
                </template>
        </v-list>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="px-8" text @click="selectDialog = false">Cerrar</v-btn>
          <v-btn color="primary" class="px-8" depressed @click="asignar">Asignar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles Pórtico {{ details.nombre }}</v-toolbar-title>
            <v-spacer/>
  </v-toolbar>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Subcondominios asignados</h3>
            </div>
          </v-card-title>
          <v-list dense>
                  <template v-for="(subcondominio, i) in selected_subcondominios">
                      <v-list-tile :key="`item-${i}`" :value="subcondominio" >
                          <v-list-tile-content>
                              <span class="black--text">{{ subcondominio.nombre }}</span>
                          </v-list-tile-content>
                      </v-list-tile>
                  </template>
              </v-list>
          <v-card-actions>
            <v-btn flat color="primary" @click="openCondosDialog">Asignar Subcondominios</v-btn>
          </v-card-actions>
        </v-card>

        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex xs12 sm2 md2>
              <div class="text-xs-center">
                <v-btn  @click="back()">
                    CANCELAR
                  </v-btn>
              </div>
              </v-flex>
            <v-flex xs12 sm2 md2>
              <div class="text-xs-center">
                <v-btn color="primary" @click="guardar()">
                    GUARDAR
                  </v-btn>
              </div>
              </v-flex>
          </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    details: {},
    subcondominios: [],
    selected_subcondominios: [],
    temp_selected: [],
    selectDialog: null,
    temp_check: null,
    checked: {},
  }),
  created() {
    this.fetchDetails();
  },
  methods: {
    back() {
      this.$router.back();
    },
    guardar() {
      this.$store.dispatch('detallesPortico/setPorticoSubcondominios', {
        portico_id: this.$route.params.id,
        subcondominios: this.selected_subcondominios.map(item => item.id),
      }).then(() => {
        this.$router.back();
      });
    },
    asignar() {
      this.selected_subcondominios = [];
      const p = this;
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.checked)) {
        if (value) {
          const subcondo = p.subcondominios.find(element => element.id === parseInt(key, 10));
          p.selected_subcondominios.push(subcondo);
        }
      }
      this.selectDialog = false;
    },
    openCondosDialog() {
      this.$store.dispatch('detallesPortico/fetchPorticosSubcondominios')
        .then((data) => {
          this.subcondominios = data.subcondominios;
          this.selected_subcondominios = this.details.subcondominios;
          this.temp_selected = this.selected_subcondominios;
          this.checked = {};
          // eslint-disable-next-line no-unused-vars
          this.subcondominios.forEach((val, i) => {
            if (this.selected_subcondominios.find(element => element.id === val.id)) {
              this.checked[val.id] = true;
            } else {
              this.checked[val.id] = false;
            }
          });
          this.loading = false;
          this.selectDialog = true;
        });
    },
    fetchDetails() {
      this.loading = true;
      this.$store.dispatch('detallesPortico/fetchPorticoDetail', this.$route.params.id)
        .then((data) => {
          this.details = data.portico;
          this.selected_subcondominios = data.portico.subcondominios;
          this.loading = false;
        });
    },
  },
  watch: {
    temp_check(vnew, vold) {
      this.checked[vnew] = !this.checked[vnew];
    },
  },
};
</script>

<style scoped>

</style>
